export default __webpack_public_path__ + "static/media/forum_img_com.9e19b141.svg";